import DialerWeb from './dialerWeb.view';

export default DialerWeb;
